const waiverAction = {
    SET_STATE: 'waiver/SET_STATE',
    HANDLE_STATE: 'waiver/HANDLE_STATE',
    SUBMISSION: 'waiver/SUBMISSION',
    WAIVER: 'waiver/WAIVER',
    CHECK_PHONE_OR_EMAIL: 'waiver/CHECK_PHONE_OR_EMAIL',

    SET_MINOR: 'waiver/SET_MINOR',
    PAYMENT_PROCESS: 'waiver/PAYMENT_PROCESS',
    CHECK_EMAIL: 'waiver/CHECK_EMAIL',

    SIGN_IN: 'waiver/SIGN_IN',
    LOGIN: 'waiver/LOGIN',
    SEND_OTP: 'waiver/SEND_OTP',
    VERIFY_OTP: 'waiver/VERIFY_OTP',
    SET_PASSWORD: 'waiver/SET_PASSWORD',
    UPLOAD_IMAGE: 'waiver/UPLOAD_IMAGE',

    FORGOT_PASSWORD: 'waiver/FORGOT_PASSWORD',

    GET_ORDER_BY_ID: 'waiver/GET_ORDER_BY_ID',

    WAIVER_UPDATE: 'waiver/WAIVER_UPDATE',
    WAIVER_UPDATE_PHONE: 'waiver/WAIVER_UPDATE_PHONE',
    WAIVER_UPDATE_EMAIL: 'waiver/WAIVER_UPDATE_EMAIL',
    WAIVER_CREATE_CHILD: 'waiver/WAIVER_CREATE_CHILD',
    WAIVER_UPDATE_CHILD: 'waiver/WAIVER_UPDATE_CHILD',
    WAIVER_DELETE_CHILD: 'waiver/WAIVER_DELETE_CHILD',
};

export default waiverAction;
